export function trackMatomoEvent(event: object) {
	const _mtm = (window as any)._mtm = (window as any)._mtm || [];
	_mtm.push(event);
}

export function activateMatomoHeatmap() {
	(window as any).njBookingReady = true;

	const _paq = (window as any)._paq = (window as any)._paq || [];
	_paq.push(['HeatmapSessionRecording::enable']);
}
